/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const HomeAltIconConfig = {
  name: 'HomeAltIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M1023.929 430.75c-0.425 5.714-2.752 10.267-6.987 13.655l-456.672 417.266c-13.55 11.008-29.641 16.514-48.27 16.514-18.631 0-34.722-5.504-48.272-16.514l-456.67-417.266c-4.235-3.387-6.562-7.941-6.987-13.655-0.425-5.719 1.058-10.695 4.446-14.928l35.017-42.933c3.387-3.81 7.833-6.139 13.337-6.987 0.997-0.082 36.619-0.135 93.282-0.16v-325.563c0-11.008 4.023-20.537 12.069-28.581 8.046-8.046 17.573-12.069 28.581-12.069h252.030v293.545h146.279v-293.545h252.085c11.008 0 20.535 4.025 28.581 12.069 8.048 8.043 12.066 17.573 12.066 28.581v325.685c55.454 0.023 90.258 0 91.323 0h1.906c5.504 0.848 9.95 3.214 13.337 7.024l35.072 42.933c3.387 4.235 4.871 9.211 4.448 14.93z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(HomeAltIconConfig);